import React, { useEffect, useState } from 'react';
import { Grid, Card, CardContent, Typography, List, ListItem, ListItemText } from '@mui/material';

const CameraPreview = ({ streamUrl, mlDataEndpoint, cameraDetails }) => {
  const [mlData, setMlData] = useState([]);

  useEffect(() => {
    // Fetch or listen for ML data
    const fetchMlData = () => {
      const eventSource = new EventSource(mlDataEndpoint);

      eventSource.onmessage = (event) => {
        try {
          const data = JSON.parse(event.data);
          setMlData((prev) => [data, ...prev].slice(0, 20)); // Keep only the latest 20 entries
        } catch (error) {
          console.error('Error parsing ML data:', error);
        }
      };

      eventSource.onerror = (error) => {
        console.error('Error with ML data stream:', error);
        eventSource.close();
      };

      return () => eventSource.close();
    };

    fetchMlData();
  }, [mlDataEndpoint]);

  return (
    <Grid container spacing={2}>

        {/* Camera Details */}
      <Grid item xs={4}>
        <Card>
          <CardContent>
            <Typography variant="h5" gutterBottom>
              Camera Details
            </Typography>
            <List>
              <ListItem>
                <ListItemText primary="Camera ID" secondary={cameraDetails['Camera ID'] || 'N/A'} />
              </ListItem>
              <ListItem>
                <ListItemText primary="Camera Status" secondary={cameraDetails['Camera Status'] || 'N/A'} />
              </ListItem>
              <ListItem>
                <ListItemText primary="Camera Manufacturer" secondary={cameraDetails['Camera Manufacturer'] || 'N/A'} />
              </ListItem>
              <ListItem>
                <ListItemText primary="Street" secondary={cameraDetails['Primary Street'] || 'N/A'} />
              </ListItem>
            </List>
          </CardContent>
        </Card>
      </Grid>
      {/* Live Stream */}
      <Grid item xs={4}>
        <Card>
          <CardContent>
            <Typography variant="h5" gutterBottom>
              Live Stream
            </Typography>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <video
                src="https://smarttrafficportal.s3.us-west-2.amazonaws.com/red_violation.mp4"
                controls
                autoPlay
                style={{
                  width: '100%',
                  height: 'auto',
                  border: '1px solid #ccc',
                  borderRadius: '8px',
                }}
              />
            </div>
          </CardContent>
        </Card>
      </Grid>

      

      {/* ML Output */}
      <Grid item xs={4}>
        <Card>
          <CardContent>
            <Typography variant="h5" gutterBottom>
              ML Data Stream
            </Typography>
            <List
              style={{
                maxHeight: '400px',
                overflowY: 'auto',
                background: '#f9f9f9',
                border: '1px solid #ccc',
                borderRadius: '8px',
              }}
            >
              {mlData.length > 0 ? (
                mlData.map((data, index) => (
                  <ListItem key={index} divider>
                    <ListItemText
                      primary={`Detection: ${data.type || 'Unknown'}`}
                      secondary={`Confidence: ${data.confidence || 'N/A'} | Time: ${
                        data.timestamp ? new Date(data.timestamp).toLocaleTimeString() : 'N/A'
                      }`}
                    />
                  </ListItem>
                ))
              ) : (
                <ListItem>
                  <ListItemText primary="No data available" />
                </ListItem>
              )}
            </List>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default CameraPreview;
